import { createAction } from 'redux-actions';
export const SET_SEARCH_RESULTS = 'RESULTS/SET_SEARCH_RESULTS';
export const setSearchResults = createAction(SET_SEARCH_RESULTS);
